export default "__VITE_ASSET__UUO01qui__"